module.exports = __webpack_public_path__ + "static/media/loader.eb7ebb03.svg";